export const instrumentationSchema = {
  scenario: [{
    name: 'fluctuation',
    value: 'fluctuation',
    setting: {},
    activity: [
      {
        name: 'fluctuationInstr',
        value: 'fluctuationInstr',
      },
      {
        name: 'fluctuationFeedback',
        value: 'fluctuationFeedback',
      },
      {
        name: 'userAction',
        value: 'userAction',
      },
      {
        name: 'fluctuationDismiss',
        value: 'fluctuationDismiss',
      },
    ],
  }],
};
